import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    GetAssignable as GetAssignableQuery,
    GetAssignableVariables as GetAssignableQueryVariables,
} from 'nutshell-graphql-types';

import GET_ASSIGNABLE from '../queries/get-assignable.graphql';

export const useGetAssignable = (id?: string | null) => {
    const {
        data,
        loading: isLoading,
        error,
    } = useQuery<GetAssignableQuery, GetAssignableQueryVariables>(GET_ASSIGNABLE, {
        // @ts-expect-error
        variables: {id},
        skip: !id,
    });

    return {
        assignable: data && data.assignable ? data.assignable : undefined,
        isLoading,
        // @ts-expect-error
        errorMessage: safelyGetGraphQLErrorMessage(error),
    };
};
